<template>
    <div class="context">
        <Icon v-if="attending" ref="icon" class="ico attending" name="check" @click="$emit('click')" />
        <Icon v-else-if="approved" ref="icon" class="ico approved" name="check" @click="$emit('click')" />
        <Icon v-else-if="invited" ref="icon" class="ico mail" name="mail" @click="$emit('click')" />
        <Icon v-else ref="icon" class="ico" name="help-circle" @click="$emit('click')" />
    </div>
</template>

<script>
import Icon from '@/components/FeatherIcon'

export default {
    name: 'Approve',
    components: { Icon },
    props: {
        approved: {
            type: Boolean,
            default: undefined,
        },
        invited: {
            type: Boolean,
            default: undefined,
        },
        attending: {
            type: Boolean,
            default: undefined,
        },
    },
}
</script>

<style scoped lang="sass">
.context
    position: relative
    z-index: 0

    .attending
        &::v-deep
            svg
                stroke: #F5F5F8

    .ico
        &:hover
            cursor: pointer
</style>
